module.exports = __webpack_public_path__ + "static/service-4-f7473b9cf857cbf80829459d48eeec28.svg";